import {
    IPublicationRequest,
    IPublicationSearchResult,
    IPublicationPageThemes,
} from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PublicationService = {
    async search(
        request: IPublicationRequest,
        signal?: AbortSignal
    ): Promise<IPublicationSearchResult> {
        const response = await fetch('/api/Publication/Search', {
            method: 'POST',
            body: JSON.stringify(request),
            headers,
            signal,
        });
        return await response.json();
    },
    async getAllTheme(
        configId: number,
        signal?: AbortSignal
    ): Promise<IPublicationPageThemes> {
        const response = await fetch(
            '/api/Publication/GetPublicationPageThemes?configId=' + configId,
            {
                method: 'GET',
                headers,
                signal,
            }
        );
        return await response.json();
    },
};
